import { render, staticRenderFns } from "./ByVariant.vue?vue&type=template&id=08d29ab2&"
import script from "./ByVariant.vue?vue&type=script&lang=js&"
export * from "./ByVariant.vue?vue&type=script&lang=js&"
import style0 from "./ByVariant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports